import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FacetsPage } from 'src/app/facets/facets-page/facets-page.component';
import moment from 'moment/moment';

@Component({
  selector: 'app-smart-table-timeago-tooltip',
  templateUrl: './smart-table-timeago-tooltip.component.html',
  styleUrls: ['./smart-table-timeago-tooltip.component.scss'],
})
export class SmartTableTimeagoTooltipComponent extends FacetsPage {
  @Input() value: any; // Value which comes in from the parent component, needs to be parsed.
  labelText;
  tooltipText: Date = null;
  user: string;
  icon: string = 'person-outline';
  emptyStateLabelText;
  showBadge: boolean = false;
  badgeConfig: { text: string; color: string; background: string };
  constructor(activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  OnPageLoad(p: Params): void {
    try {
      const parsedValue = JSON.parse(this.value);
      this.labelText = parsedValue?.label;
      this.user = parsedValue?.user;
      this.emptyStateLabelText = parsedValue?.emptyStateLabelText;
      this.showBadge = parsedValue?.showBadge;
      this.badgeConfig = parsedValue?.badgeConfig;
      if (this.user == 'Deployer') {
        this.user = 'Bot';
        this.icon = 'headphones-outline';
      }
      this.tooltipText = new Date(this.labelText);
    } catch (error) {
      console.log('Error in SmartTableTimeagoTooltipComponent', error);
    }
  }
}
